import Regionals from '../components/Regionals'

let routes = {
    path: '/regionals',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/regionals',
          name: 'Regionais e Empresas',
          component: Regionals
      },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/regionals.js